<template>
  <div>
    <div class="main school-list-main">
      <div class="title-wrap">
        <!--搜索框-->
        <div class="input-data">
          <Input v-model="keyWord" :placeholder="isAll === 'all'
            ? '支持运营名称、学校名称关键字搜索'
            : '支持学校名称关键字搜索'
            " icon="ios-search" clearable @on-enter="handleSearch">
          <Button slot="append" icon="ios-search" class="search-input-button" @click="handleSearch"
            type="primary"></Button>
          </Input>
        </div>
        <p>{{ isAll === "all" ? "学校运营人员数据表格" : "学校列表" }}</p>
      </div>
      <div class="table-main" v-if="isAll === 'all'">
        <div class="bottom-link" :class="channel != 'sy' ? '' : 'sy-bottom-link'">
          <div class="link-left" v-on:click="lookWisdomClass">
            <div class="link-icon-wrap">
              <div class="link-icon">
                <img src="../../assets/images/home/wisdome-class.png" width="100%" height="100%" />
              </div>
            </div>
            <p>一起智课</p>
          </div>
          <span class="line-split"></span>
          <div class="link-right" v-on:click="lookSystemStatistic" v-if="channel != 'sy'">
            <div class="link-icon-wrap">
              <div class="link-icon">
                <img src="../../assets/images/home/sjbb-icon.png" width="100%" height="100%" />
              </div>
            </div>
            <p>统计报表</p>
          </div>
          <span class="line-split"></span>
          <div class="link-right" v-on:click="lookSystemDashBoard">
            <div class="link-icon-wrap">
              <div class="link-icon">
                <img src="../../assets/images/home/sjzb-icon.png" width="100%" height="100%" />
              </div>
            </div>
            <p>数据展板</p>
          </div>
          <span class="line-split"></span>
          <div class="link-right" v-on:click="lookMapStatsBoard(1)">
            <div class="link-icon-wrap">
              <div class="link-icon">
                <img src="../../assets/images/home/map_icon.png" width="100%" height="100%" />
              </div>
            </div>
            <p>地图分布</p>
          </div>
          <!--<span class="line-split"></span>-->
          <!--<div class="link-right" v-on:click="lookMapStatsBoard(2)">-->
          <!--<div class="link-icon-wrap">-->
          <!--<div class="link-icon">-->
          <!--<img src="../../assets/images/home/map_icon.png" width="100%" height="100%">-->
          <!--</div>-->
          <!--</div>-->
          <!--<p>样板学校</p>-->
          <!--</div>-->
          <!--<span class="line-split"></span>-->
          <!--<div class="link-right" v-on:click="lookYQMapStatsBoard()">-->
          <!--<div class="link-icon-wrap">-->
          <!--<div class="link-icon">-->
          <!--<img src="../../assets/images/home/map_icon.png" width="100%" height="100%">-->
          <!--</div>-->
          <!--</div>-->
          <!--<p>一起分布</p>-->
          <!--</div>-->
        </div>
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="table-content">
          <template v-if="userSchoolList.length > 0">
            <template v-for="(item, index) in userSchoolList">
              <div class="school-name-item">
                <!--运营名称-->
                <div class="name-area" v-on:click="showSchoolList(index, item)">
                  <span>{{ item.rowNum }}</span>
                  <span class="name-area-text">{{ item.operName }}</span>
                  <img src="../../assets/images/school_down.png" class="name-area-icon" v-if="item.show" />
                  <img src="../../assets/images/school_up.png" class="name-area-icon" v-else />
                </div>
                <div class="school-area" v-if="item.show">
                  <template v-if="item.schools.length > 0">
                    <template v-for="(sitem, sindex) in item.schools">
                      <Col :span="4" :title="sitem.schoolName" class="school-area-col">
                      <div class="school-area-item-hover">
                        <span v-if="channel != 'sy'" class="school-area-item-hover-option" v-on:click="
                          lookSchoolInfoByRouter(
                            sitem.schoolId,
                            sitem.schoolName
                          )
                          ">统计报表</span>
                        <span class="school-area-item-hover-option" style="margin-left: 10px"
                          v-on:click="lookSchoolStatsBoard(sitem.schoolId)">数据展板</span>
                        <div class="triangle-icon"></div>
                      </div>
                      <div class="school-area-item">
                        {{ sitem.schoolName }}
                      </div>
                      </Col>
                    </template>
                  </template>
                  <template v-else>
                    <div>暂无数据~</div>
                  </template>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div>暂无数据~</div>
          </template>
        </div>
        <!--分页,大屏重复绑定情况下不显示-->
        <div class="school-laypage_main">
          <Page :total="total" :current="page" :page-size="limit" @on-change="handleCurrentChange"
            v-show="total && pageCount > 1" show-total />
        </div>
      </div>
      <div class="table-main" v-else>
        <div class="bottom-link "
          :class="userName === 'xinxuedaouser' && isShowDangAn ? 'mutli-bottom-link' : 'region-bottom-link'"
          v-if="$store.getters.roleIds.indexOf('2') > -1">
          <div class="link-right" v-on:click="lookRegionDashBoard">
            <div class="link-icon-wrap">
              <div class="link-icon">
                <img src="../../assets/images/home/sjzb-icon.png" width="100%" height="100%" />
              </div>
            </div>
            <p>数据展板</p>
          </div>
          <span class="line-split" v-if="userName === 'xinxuedaouser' && archiveSystemToken && isShowDangAn"></span>
          <div class="link-right" v-on:click="lookArchiveSystem"
            v-if="userName === 'xinxuedaouser' && archiveSystemToken && isShowDangAn">
            <div class="link-icon-wrap">
              <div class="link-icon">
                <img src="../../assets/images/home/sjzb-icon.png" width="100%" height="100%" />
              </div>
            </div>
            <p>档案系统</p>
          </div>
        </div>
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="table-content">
          <!--学校名列表-->
          <Row :gutter="-100">
            <template v-if="partSchoolList.length > 0">
              <template v-for="(schoolItem, schoolIndex) in partSchoolList">
                <Col :xs="2" :sm="4" :md="5" :lg="5" class="col-def" :title="schoolItem.schoolName">
                {{
                  schoolItem.schoolName.length > 15
                    ? schoolItem.schoolName.substring(0, 15) + "..."
                    : schoolItem.schoolName
                }}
                <!-- {{ schoolItem.schoolName }} -->
                <div class="col-cover" v-if="schoolItem.schoolName">
                  <span class="links-item" v-if="channel != 'sy'" v-on:click="
                    lookSchoolInfoByRouter(
                      schoolItem.schoolId,
                      schoolItem.schoolName
                    )
                    ">统计报表</span>
                  <span class="line-split"></span>
                  <span class="links-item link-border"
                    v-on:click="lookSchoolStatsBoard(schoolItem.schoolId)">数据展板</span>
                </div>
                </Col>
              </template>
            </template>
            <template v-else>
              <div>暂无数据~</div>
            </template>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findGetList, querySchoolPlatformList } from "../../service/api.js";
import Vue from "vue";

export default {
  name: "school-list",
  data() {
    return {
      isShowSearch: false,
      userSchoolList: [], //全部学校数据
      partSchoolList: [], //部分学校数据
      userList: [], //运营人员列表
      schoolList: [], //学校列表
      rowspanNum: 0,
      isAll: "", //all:全部  notall:局部
      keyWord: "", //关键字
      paramsData: {
        account: this.$route.query.tnuocca,
        password: this.$route.query.drowssap,
        userType: "",
      },
      page: 1,
      limit: 10,
      total: 0,
      pageCount: 0,
      channel: process.env.VUE_APP_CHANNEL,
      archiveSystemToken: "", //档案系统token
      isShowDangAn: true
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "agentId", "token"]),
  },
  components: {},
  methods: {
    /**
     * 关键字搜索
     */
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    /**
     * 获取运营人员学校列表
     */
    async getList() {
      let _this = this;
      //区域管理员
      if (_this.$store.getters.roleIds === "110" || (_this.$store.getters.userType === 6 && _this.$store.getters.schoolId === '62b79f5c75d148bb9dc70a159ecbc250')) {
        await querySchoolPlatformList({
          platformId: _this.$store.getters.schoolId,
          schoolType: 1,
          platformState: 1,
          needStudentCount: 0,
          keyWord: _this.keyWord.trim(),
          page: _this.page,
          limit: 50,
        })
          .then((data) => {
            _this.partSchoolList = data.rows;
          })
          .catch(function (error) {
            _this.$Message.error(error.message);
          });
      } else {
        let param = {
          userId: _this.userId,
          keyWord: _this.keyWord.trim(),
          userType: _this.$store.getters.userType,
          adminType: _this.$store.getters.adminType,
          roleIds: _this.$store.getters.roleIds,
          page: _this.page,
          limit: _this.limit,
        };
        await findGetList(param)
          .then(function (data) {
            _this.isAll = data.type;
            if (data.type === "all") {
              _this.userSchoolList = data.list.rows;
              _this.userSchoolList.forEach((item) => {
                Vue.set(item, "show", false);
              });
              _this.total = data.list.total_rows;
              _this.pageCount = Math.ceil(data.list.total_rows / _this.limit);
              // _this.userSchoolConvert();
            } else {
              if (data.list) {
                _this.partSchoolList = data.list[0].schools;
              }
            }
          })
          .catch(function (error) {
            _this.$Message.error(error.message);
          });
      }
    },
    /**
     * 翻页
     */
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    /**
     * 导出学校使用率
     */
    downloadRate(userId) {
      let url =
        process.env.VUE_APP_APIURL +
        "/website/school/exportSchoolUsageRate?userId=" +
        userId +
        "&date=" +
        "";
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      iframe.onload = function () {
        document.body.removeChild(iframe);
      };
      document.body.appendChild(iframe);
    },
    /**
     * 展示运营下的学校
     */
    showSchoolList(index, item) {
      item.show = !item.show;
      Vue.set(this.userSchoolList[index], "show", item.show);
    },
    /**
     * 查看学校统计报表
     */
    lookSchoolInfoByRouter(schoolId, schoolName) {
      let token = this.token;
      let routeData =
        "/mobile/schoolBoard/" +
        schoolId +
        "/" +
        schoolName +
        "?userid=" +
        this.userId +
        "&token=" +
        token;
      window.open(routeData, "_blank");
    },
    /**
     * 查看各学校数据展板
     */
    lookSchoolStatsBoard(schoolId, schoolCode) {
      let routeData = this.$router.resolve({
        //定制白云区第十五小学数博会
        name:
          schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
            ? "cloudschooldataboard"
            : "schooldataboard",
        params: {
          schoolId: schoolId,
        },
        query:{
          userid:this.userId
        }
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 查看地图展板
     * fromTag 1:全国 2:样板学校
     */
    lookMapStatsBoard(fromTag) {
      let routeData = this.$router.resolve({
        name: "map",
        query: {
          fromTag: fromTag,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 查看一起智慧课堂
     */
    lookWisdomClass() {
      let routeData = this.$router.resolve({
        name: "wisdomClassMain",
      });
      window.open(routeData.href, "_blank");

      // this.$router.push({
      //     name: "wisdomClassMain"
      // });
    },
    /**
     * 查看平台统计报表
     */
    lookSystemStatistic() {
      let routeData = this.$router.resolve({
        name: "proBoardMain",
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 查看平台数据展板
     */
    lookSystemDashBoard() {
      let routeData = this.$router.resolve({
        name: "schooldataboard",
        // name: "databorad",
        params: {
          schoolId: "0",
        },
        // params: {
        //     schoolCode: "0"
        // }
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 查看区域数据展板
     */
    lookRegionDashBoard() {
      let routeData = this.$router.resolve({
        name: "regiondataboard",
        query: {
          agentId: this.$store.getters.agentId,
          agentName: this.$store.getters.agentName,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 查看一起的地图分布
     */
    lookYQMapStatsBoard() {
      let routeData = this.$router.resolve({
        name: "wisdomclassmap",
      });
      window.open(routeData.href, "_blank");
    },
    // /**
    //  * 运营人员学校列表数据格式调整便于渲染
    //  */
    // userSchoolConvert() {
    //     let _this = this;
    //     let maxScoolCount = 0;
    //     _this.userList = [];
    //     for (let i = 0; i < _this.userSchoolList.length; i++) {
    //         let userObj = {};
    //         userObj.name = _this.userSchoolList[i].operName;
    //         userObj.userId = _this.userSchoolList[i].operId;
    //         if (maxScoolCount < _this.userSchoolList[i].schools.length) {
    //             maxScoolCount = _this.userSchoolList[i].schools.length;
    //         }
    //         _this.userList.push(userObj);
    //     }
    //     _this.schoolList = [];
    //     for (let i = 0; i < maxScoolCount; i++) {
    //         let trObj = {};
    //         trObj.trSort = i;
    //         trObj.trSchoolList = [];
    //         for (let j = 0; j < _this.userSchoolList.length; j++) {
    //             let schoolObj = {};
    //             if (_this.userSchoolList[j].schools.length > i) {
    //                 schoolObj = _this.userSchoolList[j].schools[i];
    //             }
    //             trObj.trSchoolList.push(schoolObj);
    //         }
    //         _this.schoolList.push(trObj);
    //     }
    //     _this.rowspanNum = maxScoolCount;
    // },
    /**
     * 用于江北项目演示免登陆
     */
    autoLogin() {
      let _this = this;
      if (_this.paramsData.account != "" && _this.paramsData.password != "") {
        let loginParams = {
          account: _this.paramsData.account.trim(),
          passWord: _this.paramsData.password.trim(),
          userType: _this.paramsData.userType,
        };
        _this.$store
          .dispatch("userLogin", loginParams)
          .then((res) => {
            _this.getList();
          })
          .catch((res) => {
            _this.$Message.error(res.msg);
          });
      }
    },
    /**
     * 获取档案系统token
     */
    async getArchiveSystemToken() {
      let _this = this;
      try {
        //http://47.94.74.78:8081
        ///daapi
        const response = await fetch("/daapi/dataLogin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          body: JSON.stringify({
            username: "admin",
            password: "rSFv57mjE+1u/5BAV2FvDw==",
          }),
          credentials: "omit",  // 不发送 Cookie
        });

        // 检查响应状态
        if (!response.ok) {
          console.error("请求失败，状态码:", response.status);
          const errorText = await response.text();
          console.error("错误信息:", errorText);
          return;
        }

        const data = await response.json();
        console.log("获取到的token数据:", data);

        if (data && data.token) {
          if (data.token.length > 0) {
            _this.archiveSystemToken = data.token[0];
          }
          // 将token保存到本地存储的userStore中，按照新格式保存
          // localStorage.setItem("userStore", JSON.stringify({
          //   userInfor: data.token
          // }));
        }
      } catch (error) {
        console.error("获取档案系统token失败:", error);
      }
    },
    /**
     * 打开档案系统
     */
    lookArchiveSystem() {
      let url = "http://ssda.bjxinxuedao.cn:81/bigData";
      if (this.archiveSystemToken) {
        url += "?token=" + this.archiveSystemToken;
      }
      console.log(url)
      window.open(url, "_blank");
    },
  },
  created() { },
  mounted() {
    this.$store.commit("SET_TOPHEADERNAME", "");
    this.$store.commit("SET_FREELOGINORIGIN", "");
    document.cookie = "freeLoginOrigin=;path=/";
    // this.getList();
    this.$store
      .dispatch("getUserRole", {
        userId: this.userId,
      })
      .then((res) => {
        this.getList();
        // 当用户名为xinxuedaouser时，获取档案系统token
        if (this.userName === "xinxuedaouser") {
          this.getArchiveSystemToken();
        }
      })
      .catch((res) => {
        this.$Message.error(res.msg);
      });
    // //当免登陆参数不为空时 先免登陆再获取学校列表
    // if (this.$route.query.tnuocca != undefined) {
    //     this.autoLogin();
    // } else {
    //     if (this.userId) {
    //         this.getList();
    //     } else {
    //         this.$router.push({
    //             path: "/login"
    //         });
    //     }
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/home";

.school-name-item {
  margin-bottom: 30px;
}

.name-area {
  display: flex;
  align-items: center;
  font-size: 20px;
  margin-bottom: 10px;
  cursor: pointer;
  color: #303133;

  .name-area-text {
    margin-left: 20px;
  }

  .name-area-icon {
    margin-left: 3px;
  }
}

.school-area {
  min-height: 50px;
  display: flow-root;
  padding: 10px;
  background: #f9f9f9;
  border: 1px solid #ebeef5;

  .school-area-item {
    border: 1px solid #d3d3d3;
    padding: 10px;
    margin: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    font-size: 16px;
    color: #505155;
  }

  .school-area-item-hover {
    display: none;
  }

  .school-area-col:hover .school-area-item-hover {
    display: block;
    position: absolute;
    width: 167px;
    height: 50px;
    line-height: 50px;
    background: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0px 1px 9px 0px rgba(3, 41, 66, 0.2);
    border-radius: 4px;
    top: -30px;
    left: 50%;
    transform: translate(-50%, 0);
    cursor: pointer;
    color: #505155;
    font-size: 16px;
    padding: 0 5px;
  }

  .school-area-item-hover-option:hover {
    color: #3d9ee2;
  }

  .triangle-icon {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #fff;
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translate(-50%, 0);
    cursor: pointer;
  }
}

.school-laypage_main {
  position: absolute;
  bottom: 8px;
  right: 30px;
}
</style>

<style lang="scss">
.user-def {
  color: #303133;
  text-align: center;
  font-weight: bold;
}

.school-def {
  text-align: left;
}

.ivu-col-span-lg-4 {
  display: block;
  width: 14.6666666667%;
}

.ivu-row {
  padding-top: 5px;
}

.input-data {
  .ivu-input-icon-clear {
    margin-right: 50px !important;
  }

  .ivu-input-group {
    width: 300px;
  }
}

.search-input-button {
  background-color: #2d8cf0 !important;
  color: #fff !important;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
